// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentTextConditional.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentTextFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentText on QuestionnaireQuestionChoiceOptionContentText {
  __typename
  title
  description
  conditionalContent {
    ...questionnaireQuestionChoiceOptionContentTextConditional
  }
}
    ${QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc}`;